import { gql } from "@apollo/client";

export const GET_PRINT_INFORME_RECLAMO = gql`
query printInformeReclamo($html: String!) {
    printInformeReclamo(html: $html)
}`;